import React from 'react';
import DS_ButtonLink from 'mui/components/elements/DS_ButtonLink';
import {
  BOOKING_CTA_CLASS,
  BOOKING_EVENT_CATEGORY,
  HEADER_CTA_EVENT,
} from '../../../../../assets/constants/gtmConstants';

import countries from '../../../../../assets/data/countries';
import { StyledNavButtons } from './LinksButtonsDrawerStyles';

const country = countries[process.env.GATSBY_COUNTRY_CODE];

const isSwitzerlandOrAustria = country.lang === 'de-CH' || country.lang === 'de-AT';

const NavButtons = ({ CTAButton }) => {
  return (
    !isSwitzerlandOrAustria && (
      <StyledNavButtons>
        {CTAButton?.url ? (
          <DS_ButtonLink
            {...CTAButton}
            url={CTAButton.url}
            gtmTrackingInfo={{
              gtmClassName: BOOKING_CTA_CLASS,
              gtmElementId: `${BOOKING_CTA_CLASS}GlobalHeader`,
            }}
            gtmEvent={{
              eventAction: HEADER_CTA_EVENT,
              eventCategory: BOOKING_EVENT_CATEGORY,
            }}
          />
        ) : null}
      </StyledNavButtons>
    )
  );
};

export default NavButtons;
